var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFeatherEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.25,
  height: 16,
  viewBox: "0 0 21.25 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-eye",
  "data-name": "Icon feather-eye",
  transform: "translate(-0.5 -5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1365",
  "data-name": "Path 1365",
  d: "M1.5,13S5,6,11.125,6s9.625,7,9.625,7-3.5,7-9.625,7S1.5,13,1.5,13Z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1366",
  "data-name": "Path 1366",
  d: "M18.75,16.125A2.625,2.625,0,1,1,16.125,13.5,2.625,2.625,0,0,1,18.75,16.125Z",
  transform: "translate(-5 -3.125)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}))));
export { SvgIconFeatherEye as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon feather-eye.81b8a8cbe0c1353f8543141ddb2a1d05.svg";